import React, { useEffect, useState } from "react";

interface SidebarLink {
  href: string;
  label: string;
}

interface SidebarContentProps {
  links: SidebarLink[];
}

const PageNavigation: React.FC<SidebarContentProps> = ({ links }) => {
  const [activeLink, setActiveLink] = useState<string>("");

  const handleScroll = () => {
    let closestLink: string = "";
    let closestDistance = 200;

    links.forEach((link) => {
      const element = document.querySelector(link.href);
      if (element) {
        const rect = element.getBoundingClientRect();
        const distance = Math.abs(rect.top); // Расстояние до середины экрана
        
        if (distance < closestDistance) {
          console.log(link.href + " " + distance);
          closestDistance = distance;
          closestLink = link.href;
        }
      }
    });

    if (closestLink !== activeLink) {
      setActiveLink(closestLink);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [links, activeLink]);

  return (
    <div className="sticky top-16 w-[220px] flex flex-col gap-4 divide-y py-10 max-lg:hidden xl:w-[260px] overflow-y-auto scrollbar relative">
      {links.length > 0 ? (
        <div dir="ltr" className="overflow-hidden pt-4 text-sm first:pt-0 relative">
          <h3 className="mb-4 inline-flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-text size-4"
            >
              <path d="M17 6.1H3"></path>
              <path d="M21 12.1H3"></path>
              <path d="M15.1 18H3"></path>
            </svg>
            Содержание
          </h3>
          <div className="flex flex-col gap-1 border-s-2 text-muted-foreground relative">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.querySelector(link.href);
                  element?.scrollIntoView({ behavior: "smooth", block: "start" });
                  setActiveLink(link.href); // Устанавливаем активный элемент вручную
                }}
                className={`overflow-hidden text-ellipsis py-1 transition-all ps-4 hover:text-primary ${
                  activeLink === link.href ? "active-link" : ""
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PageNavigation;
